
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.35 20l-3.525-3.55 1.4-1.4 2.125 2.125 4.25-4.25L23 14.35 17.35 20zM2 22V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 014 2h16c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v7h-2V4H4v13.125L5.15 16H12v2H6l-4 4z","fill":"#fff"}})])
          )
        }
      }
    